module.exports = function getResource(label, vars = []) {
    const resources = { continueShopping: 'Continue shopping' };
    return resources[label];
};
